import Chart, { Props } from "react-apexcharts";

export default function RadarChart({ isOpened } : { isOpened: boolean }) {
  const options: Props = {
    chart: {
      type: "radar",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
        type: "xy",
      },
    },
    fill: {
      opacity: 0.6,
    },
    plotOptions: {
      radar: {
        offsetX: isOpened ? 7.5 : 0,
        offsetY: isOpened ? -10 : 0,
        polygons: {
          strokeColors: isOpened ? 'transparent' : '#CCCCCC',
          strokeWidth: isOpened ? 0 : 1,
          connectorColors: isOpened ? 'transparent' : '#CCCCCC',
          fill: {
            colors: undefined
          }
        }
      }
    },
    stroke: {
      show: false,
    },
    markers: {
      size: isOpened ? 3 : 2,
    },
    yaxis: {
      stepSize: 0.05,
      min: 0.8,
      show: false
    },
    xaxis: {
      categories: ["Oil", "Water", "Gas"],
      labels: {
        show: isOpened,
        style: {
          fontSize: "12px",
          colors: ['#000000', '#000000', '#000000'],
          fontWeight: 600
        },
      },
    },
    dataLabels: {
      enabled: isOpened,
      offsetY: 15,
      style: {
        fontSize: "12px",
      },
    },
    legend: {
      show: false,
    },
  };

  const series = [
    {
      name: "Series 1",
      data: [0.913, 0.978, 0.975],
      color: '#FFBAC6'
    },
    {
      name: "Series 2",
      data: [0.952, 0.919, 0.921],
      color: '#96E2D3'
    },
  ];

  return (
    <Chart options={options} series={series} type="radar" height={"100%"} />
  );
}
